import { motion } from 'framer-motion'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck, faMinus, faArrowRight } from '@fortawesome/free-solid-svg-icons'
import CTAButton from './CTAButton'
import { boxvar2dyndelay } from '../core.js'

function FeatureIcon({ state }) {
    if (state === true) return <FontAwesomeIcon className="pricing_feat_icon pricing_feat_icon-in" icon={faCheck} />
    if (state === false) return <FontAwesomeIcon className="pricing_feat_icon pricing_feat_icon-out" icon={faMinus} />
    return <FontAwesomeIcon className="pricing_feat_icon pricing_feat_icon-info" icon={faArrowRight} />
}

export default function PricingCard({ tier, delay, ctaTitle = 'Angebot anfragen' }) {
    return (
        <motion.div
            variants={boxvar2dyndelay}
            custom={delay}
            initial="hidden"
            exit="hidden"
            whileInView="visible"
            viewport={{ once: false, margin: '-50px' }}
            className={'pricing_card' + (tier.featured ? ' pricing_card-featured' : '')}
        >
            {tier.badge && <span className="pricing_badge">{tier.badge}</span>}
            <h3 className="pricing_card_name">{tier.name}</h3>
            <span className="pricing_card_forwho">{tier.forwho}</span>
            <div className="pricing_price">
                <span className="pricing_price_value">{tier.price}</span>
                <span className="pricing_price_note">{tier.priceNote}</span>
            </div>
            <p className="pricing_card_sales">{tier.sales}</p>
            <ul className="pricing_feat_list">
                {tier.features.map((f, i) => (
                    <li key={i} className={f.in === false ? 'pricing_feat-out' : ''}>
                        <FeatureIcon state={f.in} />
                        <span>{f.t}</span>
                    </li>
                ))}
            </ul>
            <CTAButton
                className="pricing_card_cta"
                showArrow={true}
                title={ctaTitle}
                href={'/support?paket=' + tier.paket}
            />
        </motion.div>
    )
}

export function BundleCard({ bundle, delay, ctaTitle = 'Bundle anfragen' }) {
    return (
        <motion.div
            variants={boxvar2dyndelay}
            custom={delay}
            initial="hidden"
            exit="hidden"
            whileInView="visible"
            viewport={{ once: false, margin: '-50px' }}
            className={'pricing_card' + (bundle.featured ? ' pricing_card-featured' : '')}
        >
            {bundle.badge && <span className="pricing_badge">{bundle.badge}</span>}
            <h3 className="pricing_card_name">{bundle.name}</h3>
            <div className="pricing_price">
                <span className="pricing_price_value">{bundle.price}</span>
                <span className="pricing_price_note">{bundle.priceExtra}</span>
            </div>
            <p className="pricing_bundle_contains">{bundle.contains}</p>
            <p className="pricing_card_sales">{bundle.sales}</p>
            <CTAButton
                className="pricing_card_cta"
                showArrow={true}
                title={ctaTitle}
                href={'/support?paket=' + bundle.paket}
            />
        </motion.div>
    )
}
